/**
 * 发票中心 tab 与状态枚举
 * 待开票走订单列表 invoiceStatus；其余 tab 走发票列表 status
 */

/** 订单侧：0=未开票（可申请） */
export const ORDER_INVOICE_STATUS = {
  NONE: 0,
};

/** 发票侧状态：0审核中 1审核通过 2审核驳回 3已开票 4已作废 5已申请作废 */
export const INVOICE_STATUS = {
  PENDING_REVIEW: 0,
  APPROVED: 1,
  REJECTED: 2,
  ISSUED: 3,
  VOIDED: 4,
  CANCEL_REQUESTED: 5,
};

/** 发票中心顶部 tabs */
export const INVOICE_TABS = [
  {
    key: 'pending',
    label: '可开票',
    source: 'order',
    // 订单 invoiceStatus === 0
    orderInvoiceStatus: ORDER_INVOICE_STATUS.NONE,
  },
  {
    key: 'processing',
    label: '开票中',
    source: 'invoice',
    // 审核中、审核通过
    invoiceStatuses: [INVOICE_STATUS.PENDING_REVIEW, INVOICE_STATUS.APPROVED],
  },
  {
    key: 'issued',
    label: '已开票',
    source: 'invoice',
    invoiceStatuses: [INVOICE_STATUS.ISSUED, INVOICE_STATUS.CANCEL_REQUESTED],
  },
  {
    key: 'rejected',
    label: '已驳回',
    source: 'invoice',
    invoiceStatuses: [INVOICE_STATUS.REJECTED],
  },
  {
    key: 'voided',
    label: '已作废',
    source: 'invoice',
    invoiceStatuses: [INVOICE_STATUS.VOIDED],
  },
];

/** 发票种类：0普票 1专票 */
export function invoiceCategoryText(invoiceCategory) {
  const n = Number(invoiceCategory);
  if (n === 0) return '普票';
  if (n === 1) return '专票';
  return '—';
}

/** 发票预览配置 */
export const INVOICE_PREVIEW_CONFIG = {
  /** true：html2canvas 转图片展示；false：直接渲染 HTML（便于调样式） */
  imageCapture: true,
};



// WEBPACK FOOTER //
// ./src/view/client/personal-center/panels/InvoiceCenter/constants.js